import { useMemo } from "react";
import { useSelector } from "react-redux";

import { DEFAULT_MODE, mergeRules } from "./auctionRules";

const EMPTY = {};

// The admin stamps the mode and the resolved rule set onto the session, and
// bidder and curator screens each keep their own copy of that session in the
// store, so read whichever one is populated. Returns the stored object as-is so
// the selector stays reference-stable across unrelated store updates.
const selectSession = (state) =>
  state.bidder?.session?.sessionId
    ? state.bidder.session
    : state.curator?.session || EMPTY;

export const useAuctionMode = () =>
  useSelector((state) => selectSession(state)?.auctionMode) || DEFAULT_MODE;

// Falls back to the mode's defaults for a session started before rules could be
// edited, so a screen always has a complete set of numbers to show.
export const useAuctionRules = () => {
  const session = useSelector(selectSession);
  // Memoised so callers can safely put the result in a dependency array;
  // mergeRules builds a fresh object every call.
  return useMemo(
    () => mergeRules(session?.auctionMode || DEFAULT_MODE, session?.rules),
    [session?.auctionMode, session?.rules]
  );
};
